import { useMemo, useState } from 'react';
import { JANELA_VENCIMENTO_PADRAO_DIAS } from '../utils/acreditacaoOpcoes';

const MS_POR_DIA = 86400000;

// Filtro CORE/Status/janela de dias + ordenação por data — usado tanto na aba de vencimentos
// (vigência) quanto na de corretivas (prazo da ação), por hospital ou pelo portfólio inteiro.
// `campoData` é o campo de data-limite de cada item (`data_vencimento_vigencia` ou `prazo_acao`).
// A janela de "próximo do vencimento" é sempre recalculada no cliente a partir da data crua —
// não depende do farol pré-calculado no backend (que usa um limiar fixo de 60 dias) — assim
// dá pra oferecer 7/30/60/90 dias sem precisar trocar a classificação do backend.
export default function useFiltroVencimentos(
  base,
  { campoData = 'data_vencimento_vigencia', diasIniciais = JANELA_VENCIMENTO_PADRAO_DIAS } = {}
) {
  const [filtroCore, setFiltroCore] = useState('todos');
  const [filtroStatus, setFiltroStatus] = useState('todos');
  const [filtroVigencia, setFiltroVigencia] = useState('todos');
  const [dias, setDias] = useState(diasIniciais);

  const vencimentos = useMemo(() => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    return base
      .filter((v) => v[campoData])
      .map((v) => {
        const diasRestantes = Math.round((new Date(v[campoData]) - hoje) / MS_POR_DIA);
        return { ...v, _diasRestantes: diasRestantes, _statusJanela: diasRestantes < 0 ? 'vencido' : 'a_vencer' };
      })
      .filter((v) => v._diasRestantes <= dias)
      .filter((v) => filtroCore === 'todos' || v.core)
      .filter((v) => filtroStatus === 'todos' || v.status === filtroStatus)
      .filter((v) => filtroVigencia === 'todos' || v._statusJanela === filtroVigencia)
      .sort((a, b) => (a[campoData] < b[campoData] ? -1 : 1));
  }, [base, campoData, filtroCore, filtroStatus, filtroVigencia, dias]);

  return {
    filtroCore,
    setFiltroCore,
    filtroStatus,
    setFiltroStatus,
    filtroVigencia,
    setFiltroVigencia,
    dias,
    setDias,
    vencimentos,
  };
}
